'use client'
import { useDictionary } from '@/contexts/DictionaryContext'
import { InfiniteMovingCards } from './ui/infinite-moving-cards'

const Logos = () => {
  const { dictionary } = useDictionary()

  const logos = [
    { src: '/assets/images/partners/siemens_logo.png', alt: 'siemens_logo' },
    { src: '/assets/images/partners/atvise_logo.png', alt: 'atvise_logo' },
    { src: '/assets/images/partners/ignition_logo.png', alt: 'ignition_logo' },
    { src: '/assets/images/partners/allen_logo.png', alt: 'allen_logo' },
    { src: '/assets/images/partners/man-3.png', alt: 'man_logo' },
    { src: '/assets/images/partners/wago_logo.png', alt: 'wago_logo' },
    { src: '/assets/images/partners/festo_logo.png', alt: 'festo_logo' },
  ]

  const logoItems = logos.map(logo => ({
    quote: '',
    name: dictionary.home.partners[logo.alt as keyof typeof dictionary.home.partners],
    title: '',
    src: logo.src,
  }))

  return (
    <div className='container mx-auto place-items-center justify-center '>
      <InfiniteMovingCards
        items={logoItems}
        direction='left'
        speed='normal'
        pauseOnHover={true}
        className='flex w-full flex-row place-items-center justify-center gap-12'
      />
    </div>
  )
}

export default Logos
